import React, { useState } from "react";
import { BlockJson, CategoryJsonModel } from "../../models/BlockTransportSystemJsonModel";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IProps {
    category?: CategoryJsonModel;
    categories?: CategoryJsonModel[];
    blocks?: BlockJson[];
    isShow: boolean;
    onClickApply: (targetBlocks: BlockJson[], toCategoryId: string) => Promise<void>;
    onClickClose: () => void;
}

const CategoryBlocksChangeModal = ({
    category,
    categories,
    blocks,
    isShow,
    onClickApply,
    onClickClose
}: IProps) => {
    const { t } = useTranslation();
    const [isWorking, setIsWorking] = useState<boolean>(false);
    const [targetType, setTargetType] = useState<string>();
    const [toCategoryId, setToCategoryId] = useState<string>();
    const typeCounts = blocks
        ?.filter((block) => block?.data?.categoryId === category?.id)
        .map((block) => block.data.type)
        .reduce<Record<string, number>>((acc, cur) => {
            acc[cur] = (acc[cur] || 0) + 1;
            return acc;
        }, {});

    return (
        <Modal show={isShow} onHide={() => onClickClose()}>
            <Modal.Header closeButton>{t("block-type-list")}</Modal.Header>
            <Modal.Body>
                <Form.Label>{category?.id}</Form.Label>
                <Form.Label>{category?.name}</Form.Label>
                <Form.Select
                    disabled={isWorking}
                    onChange={(e) => setTargetType(e.target.value)}
                >
                    <option key={""} value={""}>{t("none")}</option>
                    {Object.entries(typeCounts).map(([key, value]) =>
                        <option key={key} value={key}>{`${key}(${value})`}</option>
                    )}
                </Form.Select>
                <hr />
                <Form.Label>{t("category-changed-target")}</Form.Label>
                <Form.Select
                    disabled={isWorking}
                    onChange={(e) => setToCategoryId(e.target.value)}
                >
                    <option key={""} value={""}>{t("none")}</option>
                    {categories?.map((category) =>
                        <option key={category?.id} value={category?.id}>
                            {`${category?.name} [${category?.dedicatedProducts && [...category?.dedicatedProducts]}]`}
                        </option>
                    )}
                </Form.Select>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={!targetType || !toCategoryId || isWorking}
                    onClick={async () => {
                        setIsWorking(true);
                        try {
                            const targetBlocks = blocks?.filter(block => block.data.categoryId === category?.id! && block.data.type === targetType);
                            if (targetBlocks && targetBlocks.length > 0) {
                                await onClickApply(targetBlocks, toCategoryId!);
                                onClickClose();
                            }
                        } finally {
                            setIsWorking(false);
                        }
                    }}>
                    {isWorking &&
                        <Spinner
                            className="me-1"
                            animation="border"
                            size="sm"
                            role="status"
                        />}
                    {t("button-apply")}
                </Button>
                <Button
                    disabled={isWorking}
                    variant="secondary"
                    onClick={() => onClickClose()}>{t("button-close")}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CategoryBlocksChangeModal;